import { ConfigService } from '@nuskin/ns-util';

export default {
    install (Vue) {
        const marketConfig = ConfigService.getMarketConfig();

        // Sets up reactivity for the market config
        const _vm = new Vue({
            data: () => ({
                marketConfig
            })
        });

        Vue.mixin({
            beforeCreate () {
                // exposes marketConfig as this.$marketConfig
                Object.defineProperty(this, '$marketConfig', {
                    get: () => _vm.marketConfig
                });
            }
        });
    }
};
